export const PREPAID_COLUMN_OPTIONS = {
  cash: 'دفع عند الاستلام (Cash)',
  prepaid: 'مسبق الدفع (Prepaid)',
};
